export class Producto {
    clasificacionImpuesto: string;
    cliente: string;
    codigo: number;
    conversorUnidadMedidaVenta: string;
    descripcion: string;
    habilitacion:boolean;
    id: string;
    idCategoriaProducto: string;
    idClaseValuacion: string;
    idCompania: string;
    idDivision: string;
    idGrupoProducto: string;
    idGrupoProductoEl: string;
    idJerarquiaProducto: string;
    idPais: string;
    idPaisOrigen: string;
    idPlanta:string;
    idSalesOrg: string;
    idUnidadMedidaBase: string;
    idUnidadMedidaVenta: string;
    lineaProducto:string;
    profitCenter: string;
    status: string;
    unidadesCaja: number;
    unidadesPallet: number;
    usuarioRedUltimaActualizacion: string;
    displayValue:string;
    codigoArticuloMyV: string
    codigoArticuloCoagra: string
}